import { Scissors } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-stone-900 py-10 bg-stone-950"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-stone-500">
        <div className="flex items-center gap-2">
          <Scissors size={14} className="text-amber-500" />
          <span className="font-display tracking-tight text-stone-300">
            Andooozy<span className="text-amber-500">Cutzz</span>
          </span>
          <span className="ml-3 text-stone-600">
            © {new Date().getFullYear()}
          </span>
        </div>
        <div className="text-xs tracking-[0.25em] uppercase text-stone-600">
          Crafted with steel & care
        </div>
      </div>
    </footer>
  );
}
